import script from "./detail.vue?vue&type=script&setup=true&lang=js"
export * from "./detail.vue?vue&type=script&setup=true&lang=js"

import "./detail.vue?vue&type=style&index=0&id=7be0b83d&scoped=true&lang=less"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7be0b83d"]])

export default __exports__